import { useMutation } from '@tanstack/react-query';
import { createProject } from "@/api/project"; 
import { CreateProjectData, ReturnProjectData } from "@/types/project"; 
import { PostParam } from "@/types/index"; 

export function useCreateProject(props?: PostParam) {
  const { onSuccess, onError } = props || {};

  return useMutation<ReturnProjectData, Error, CreateProjectData>({
    mutationFn: createProject,
    onSuccess,
    onError
  });
}